import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/steps/locked.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function Locked({ className }) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                { [className]: className !== null },
            ])}
        >
            <h3 className={styles.title}>
                <FormattedMessage
                    defaultMessage="Sorry, you did not enter the pincode in time to play."
                    description="Live title"
                />
            </h3>
        </div>
    );
}

Locked.propTypes = propTypes;
Locked.defaultProps = defaultProps;

export default Locked;
